var map = {
	"./copy.svg": 36444,
	"./dislike.svg": 82542,
	"./edit.svg": 19855,
	"./like.svg": 55884,
	"./menu-left.svg": 6313,
	"./menu-right.svg": 99363,
	"./plus.svg": 10732,
	"./refresh.svg": 64582,
	"./toggle-left.svg": 63258,
	"./toggle-right.svg": 97121
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 13573;